import AccommodationEventDatalist, { AccommodationEventDatalistType } from "components/entities/accommodation/events/AccommodationEventDatalist";
import { uuid } from "config/app-constants";
import { Conditions } from "utilities/datalist/datalist-filter-utilities";
import { DateUtil } from "utilities/date-utilities";

const AccommodationEventPrintPage = () => {
    const config: AccommodationEventDatalistType['config'] = {
        defaultView: 'card',
        dataSource: {
            filter: {
                logic: 'or',
                id: uuid(),
                filters: [
                    {
                        id: uuid(),
                        name: 'date',
                        type: 'date',
                        condition: Conditions.gte,
                        value: DateUtil.toIsoDate()
                    },
                    {
                        id: uuid(),
                        name: 'isDone',
                        type: 'boolean',
                        condition: Conditions.eq,
                        value: false
                    }
                ]
            }
        },
        page: {
            pageSize: 20
        },
        table: {
            render: {
                actions: () => undefined
            }
        }
    };

    return (
        <AccommodationEventDatalist
            config={config}
            hideActions
            name="event-datalist-print-page"
            addNew
        />
    );
};

export default AccommodationEventPrintPage;
